// removed by extract-text-webpack-plugin
module.exports = {"container":"styles-container--25c0J","ghosted":"styles-ghosted--1hu3r","wrapper":"styles-wrapper--3Q86O","comparison-before":"styles-comparison-before--1JQKt","comparison-after":"styles-comparison-after--2tDjI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu/styles.scss
// module id = tlbl
// module chunks = 3